import React, { Component } from 'react';
import { Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getTeamCssClass, getFriendlyTeamName } from '../../helpers/clubHelper';

export default class ClubTeams extends Component {
  render() {
    return (
      <div className="team-types">
        {this.props.teams.map((team, index) => (
          <Popup
            key={index}
            trigger={<span className={getTeamCssClass(team)} />}
            content={getFriendlyTeamName(team)}
          />
        ))}
      </div>
    );
  }
}

ClubTeams.propTypes = {
  teams: PropTypes.PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      gender: PropTypes.string.isRequired
    })
  ).isRequired
};



// WEBPACK FOOTER //
// ./src/components/Club/ClubTeams.js